module.exports = __webpack_public_path__ + "static/media/aziinback.e850d5ca.jpg";